import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';
import Moment from 'moment';
import ItemLotAssign from './item-lot-assign';
import {connect} from 'react-redux';
import Form from 'components/react-validation/components/form';
import Input from 'components/react-validation/components/input';
import DatePicker from 'components/react-validation/components/datepicker';
import Submit from 'components/react-validation/components/submit';
import * as Vali from 'helper/validator-helper';
import {withRouter} from 'react-router-dom';
import {isNull, isNumber} from 'lodash';
import * as ProjectActionType from 'Projects/constants';
import TagsInputs from 'components/react-validation/components/tags-input';

const TAGS_LIST = [9, 13, 188];

class ItemLotList extends React.Component {
    static propTypes = {
      onClose: PropTypes.func,
      dispatch: PropTypes.func,
      projectId: PropTypes.string,
      inventoryItemProfile: PropTypes.array,
      inventoryId: PropTypes.string,
      breadcrumbsHistory: PropTypes.string,
      history: PropTypes.object,
      location: PropTypes.any,
      onBackToEditInventoryItems: PropTypes.func,
      lotListAssign: PropTypes.array,
      inventoryItemId: PropTypes.string,
      isCreateMode: PropTypes.bool
    }
    constructor(props) {
      super(props);
      this.state = {
        serialNumber: '',
        serviceFee: '',
        purchaseDate: '',
        location: [],
        assignedPlanPopup: props.isCreateMode === true ? true : false,
        hoverLotItem: false,
        lotListAssign: []
      };
    }

    componentDidMount() {
      if (this.props.inventoryItemId) {
        this.getInventoryProfile(this.props.inventoryItemId);
        this.props.dispatch({
          type: ProjectActionType.GET_LIST_LOT_ASSIGN_INVENTORY_ITEM_ASYNC,
          params: {
            id: this.props.inventoryItemId
          }
        });
      }

      window.scrollTo(0, 0);
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.inventoryItemProfile !== nextProps.inventoryItemProfile) {
        this.setState({
          name: nextProps.inventoryItemProfile.name
        });
      }

      if (this.props.lotListAssign !== nextProps.lotListAssign) {
        this.setState({
          lotListAssign: nextProps.lotListAssign
        });
      }
    }

    getInventoryProfile = (id, callback) => {
      this.props.dispatch({
        type: ProjectActionType.GET_INVENTORY_ITEM_PROFILE_ASYNC,
        params: {
          id: id
        },
        callback
      });
    }

    form = {};
    onClose = () => {
      this.props.onClose();
    }

    onBack = () => {
      this.props.onBackToEditInventoryItems();
    }

    onCustomAction = () => {
      this.onClose();
    }

    onOpenItemLotAssignModal = e => {
      e.preventDefault();

      this.setState({
        assignedPlanPopup: !this.state.assignedPlanPopup
      });
    }

    onFetchListLotAssign = () => {
      this.props.dispatch({
        type: ProjectActionType.GET_LIST_LOT_ASSIGN_INVENTORY_ITEM_ASYNC,
        params: {
          id: this.props.inventoryItemId
        }
      });
    }

    onCloseToInventoryItemPopup = () => {
      this.setState({
        assignedPlanPopup: false
      });
    }

    onChangeDate = (type, value) => {
      if (value) {
        if (Moment(value, 'MM/DD/YYYY', true).isValid()) {
          this.setState({
            [type]: value,
            error: {...this.state.error, [type]: null}
          });
        } else if (Moment(value, 'DD/MM/YYYY', true).isValid()) {
          let convertDate = (Moment(Moment(value, 'DD/MM/YYYY')).format('MM/DD/YYYY'));
          this.setState({
            [type]: convertDate,
            error: {...this.state.error, [type]: null}
          });
        } else if (Moment(value, 'YYYY/DD/MM', true).isValid()) {
          let convertDate = (Moment(Moment(value, 'YYYY/DD/MM')).format('MM/DD/YYYY'));
          this.setState({
            [type]: convertDate,
            error: {...this.state.error, [type]: null}
          });
        } else if (Moment(value, 'YYYY/MM/DD', true).isValid()) {
          let convertDate = (Moment(Moment(value, 'YYYY/MM/DD')).format('MM/DD/YYYY'));
          this.setState({
            [type]: convertDate,
            error: {...this.state.error, [type]: null}
          });
        } else {
          this.setState({
            error: {...this.state.error, [type]: 'Invalid date.'}
          });
        }
      } else {
        this.setState({
          [type]: value,
          error: {...this.state.error, [type]: null}
        });
      }
    }

    onSubmit = (e, lotId) => {
      e.preventDefault();
      const formValues = this.form[lotId].getValues();
      this.setState({
        hoverLotItem: null
      }, () => {
        this.props.dispatch({
          type: ProjectActionType.UPDATE_LOT_LIST_INVENTORY_ASYNC,
          params: {
            id: lotId,
            serialNumber: formValues.serialNumber,
            serviceFee: formValues.serviceFee === '' ? null : formValues.serviceFee,
            purchaseDate: formValues.purchaseDate ? Moment(formValues.purchaseDate).hour(Moment().hour()) : formValues.purchaseDate,
            tagLocations: formValues.location
          }, callback: () => {
            this.onFetchListLotAssign();
          }
        });
      });
    }

    onRemoveAssignLot = (lotId) => {
      this.props.dispatch({
        type: ProjectActionType.DELETE_LOT_LIST_INVENTORY_ITEM_ASYNC,
        params: {
          lotId: lotId
        },
        callback: () => {
          this.onFetchListLotAssign();
        }
      });
    }

    onFocus = (id) => {
      if (this.state.hoverLotItem !== id) {
        this.setState({hoverLotItem: id});
      }

      if (this.state.hoverLotItem) {
        return;
      }

      this.setState({
        hoverLotItem: id
      });
    }

    onNotFocus = () => {
      this.setState({
        hoverLotItem: null
      });
    }

    onChangeText = (e, type) => {
      this.setState({
        [type]: e.target.value
      });
    }

    handleChangeTag = (tags) => {
      let tagsValid = [];
      tags.map(tag => {
        if (tag) {
          tagsValid.push(tag);
        }
      });
      this.setState({
        location: tagsValid
      });
    }

    render() {
      if (!this.props.inventoryItemProfile.name) {return null;}

      const {breadcrumbsHistory} = this.props;
      const {assignedPlanPopup, lotListAssign} = this.state;
      let {serialNumber, serviceFee, purchaseDate} = this.state;

      const breadcrumbs = [
        {title: 'Inventory items', url: breadcrumbsHistory, onCustomAction: this.onCustomAction},
        {title: `${this.props.inventoryItemProfile.name}`, url: breadcrumbsHistory, onCustomAction: this.onBack},
        {title: 'Lots installed', url: ''}
      ];

      return (
        <React.Fragment>
          <div className='list-lot-inventory'>
            <div className='container-fluid'>
              <h4 style={{marginTop: 0}}>Lots installed</h4>

              <Breadcrumb breadcrumbs={breadcrumbs} />

              <div className='assign-lot-inventory-items row'>
                <button
                  onClick={(e) => this.onOpenItemLotAssignModal(e)}
                  className='btn btn-primary btn-siteone-default'
                >
                  <span className='fa fa-plus icon' />Add
                </button>
              </div>

              <div className='assign-plan-lot-inventory-list'>
                {
                  lotListAssign.map(lot => {
                    let listTagsLocation = lot.tagLocations.map(x => x.id);

                    return (
                      <div style={this.state.hoverLotItem === lot.id ? {marginBottom: 25} : {}} key={lot.id} className='lot-item'>
                        <Form ref={c => { this.form[lot.id] = c; }} onSubmit={(e) => this.onSubmit(e, lot.id)}>
                          <div className={this.state.hoverLotItem === lot.id ? 'is-style-lot-header row' : 'is-style-lot-header-not-hover row'}>
                            <div style={{display: 'inline-flex'}} className='col-md-12 col-xs-12'>
                              <h4 style={{fontWeight: 'bolder', marginRight: 15}} className='title'>{lot.name}, {lot.streetAddress}</h4>
                              <div style={{float: 'right', marginTop: 5, marginRight: 15}}>
                                <div style={{position: 'absolute', bottom: -5}} className='remove-button-wrapper lot-installed-remove-btn' onClick={() => this.onRemoveAssignLot(lot.id)}>
                                  <div className='remove-button icon-remove-ic' />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={this.state.hoverLotItem === lot.id ? 'add-new-lot-installed row' : 'add-new-lot-installed-not-hover row'}>
                            <div className='col-md-3 col-xs-3'>
                              <div className='form-group margin-left-15'>
                                <label>Serial Number</label>
                                <Input
                                  name='serialNumber'
                                  ref='serialNumber'
                                  placeholder='Serial Number'
                                  className='form-control'
                                  autoComplete={false}
                                  value={!isNull(lot.serialNumber) ? lot.serialNumber : serialNumber}
                                  max='254'
                                  maxLength='254'
                                  onFocus={() => this.onFocus(lot.id)}
                                  validations={[Vali.maxlength]} />
                              </div>
                            </div>
                            <div className='col-md-3 col-xs-3'>
                              <div className='form-group margin-left-15'>
                                <label>Price/Service fee</label>
                                <div style={{position: 'relative'}}>
                                  <span style={{top: 9}} className='addon-input'>$</span>
                                  <Input
                                    style={{paddingLeft: 20}}
                                    name='serviceFee'
                                    ref='serviceFee'
                                    autoComplete={false}
                                    className='form-control'
                                    value={isNumber(lot.serviceFee) && !isNull(lot.serviceFee) ? lot.serviceFee.toString() : serviceFee}
                                    type='number'
                                    onFocus={() => this.onFocus(lot.id)}
                                    validations={[Vali.isFloatTwoDecimal]} />
                                </div>
                              </div>
                            </div>
                            <div className='col-md-3 col-xs-3'>
                              <div className='form-group margin-left-15'>
                                <label>Purchase date</label>
                                <DatePicker
                                  onFocus={() => this.onFocus(lot.id)}
                                  ref='purchaseDate'
                                  name='purchaseDate'
                                  value={!isNull(lot.purchaseDate) ? Moment(lot.purchaseDate).format('MM/DD/YYYY') : purchaseDate}
                                />
                              </div>
                            </div>
                            <div className='col-md-3 col-xs-3'>
                              <div className='form-group margin-left-15'>
                                <label>Location</label>
                                <TagsInputs
                                  ref='location'
                                  name='location'
                                  className='tag-input-lot-installed form-control'
                                  value={listTagsLocation}
                                  addKeys={TAGS_LIST}
                                  onlyUnique={true}
                                  onFocus={() => this.onFocus(lot.id)}
                                />
                              </div>
                            </div>
                            <div className='col-md-12 col-xs-12'>
                              <div className='on-hide-submit-lot-installed-btn'>
                                <span className='btn btn-siteone-default' onClick={this.onNotFocus}>Cancel</span>
                                <Submit className=' btn btn-primary btn-siteone'>Submit</Submit>
                              </div>
                            </div>
                          </div>
                        </Form>
                      </div>
                    );
                  })
                }
              </div>

              {
                assignedPlanPopup &&
                <ItemLotAssign
                  projectId={this.props.projectId}
                  isOpen={this.state.assignedPlanPopup}
                  inventoryItemId={this.props.inventoryId}
                  onClose={this.onCloseToInventoryItemPopup}
                />
              }
            </div>
          </div>
        </React.Fragment>
      );
    }
}

const mapStateToProps = (state) => {
  return {
    lotListAssign: state.ProjectStore.lotListAssign,
    inventoryItemId: state.ProjectStore.inventoryItemId,
    inventoryItemProfile: state.ProjectStore.inventoryItemProfile
  };
};

export default withRouter(connect(mapStateToProps)(ItemLotList));



// WEBPACK FOOTER //
// ./src/Projects/Components/Inventory/item-lot-list.js